import React, { useEffect, useState } from "react";
import { Button, Col, Row, Stack } from "react-bootstrap";
import { fetchDepartments, postDepartment, postJob } from "../../../services/httpClient";
import Input from "../../ui/Input";
import { unsavedChanges } from "../../../App";
import DepartmentCard from "./DepartmentCard";
import SelectObjectTypeahead from "../../ui/SelectObjectTypeahead";

interface JobsState {
  jobs: any;
  getJobs: any;
  setOrgToSave: any;
  showAddJobDept: boolean;
  setShowAddJobDept: (value: boolean) => void;
  setErrMessage: any;
  setShowToast: any;
  setToastText: any;
  setToastBody: any;
}

const Jobs = ({
  jobs,
  getJobs,
  setOrgToSave,
  showAddJobDept,
  setShowAddJobDept,
  setErrMessage,
  setShowToast,
  setToastText,
  setToastBody,
}: JobsState) => {
  const [newDept, setNewDept] = useState<any>({});
  const [newJob, setNewJob] = useState<string>("");
  const [newPositionTotal, setNewPositionTotal] = useState<number>();
  const [departments, setDepartments] = useState<any>([]);

  useEffect(() => {
    getDepartments();
  }, []);

  const getDepartments = () => {
    fetchDepartments()
      .then((res: any) => {
        const depts = res[0].data;
        setDepartments(depts);
      })
      .catch((err: any) => {
        console.log(err);
      });
  };

  const onAddDepartment = (deptName: string) => {
    return postDepartment({ name: deptName })
      .then((res: any) => {
        getDepartments();
        return { key: res[0].data.dept_key, name: deptName, id: res[0].data.dept_id };
      })
      .catch((err: any) => {
        console.log(err);
        throw err;
      });
  };

  const updateNewDept = (e: any) => {
    setNewDept(e);
    unsavedChanges.value = true;
    setOrgToSave(true);
  };

  const updateNewJob = (e: any) => {
    setNewJob(e.target.value);
    unsavedChanges.value = true;
    setOrgToSave(true);
  };

  const updateNewPositionTotal = (e: any) => {
    setNewPositionTotal(e.target.value);
    unsavedChanges.value = true;
    setOrgToSave(true);
  };

  const onClickSaveJob = (isDone: boolean = false, deptId: string) => {
    const _job = {
      name: newJob,
      positions_total: newPositionTotal,
    };

    setErrMessage("");

    postJob(_job, deptId)
      .then((res: any) => {
        setShowToast(true);
        setToastText("Job Created");
        setToastBody(newJob);
        setNewJob("");
        setNewPositionTotal(undefined);
        unsavedChanges.value = false;
        setOrgToSave(false);
        if (isDone) {
          setNewDept({});
          setShowAddJobDept(false);
        }
        getJobs(true);
      })
      .catch((err: any) => {
        setErrMessage(err?.response?.data?.msg);
        window.scrollTo({
          top: 0,
          behavior: "auto",
        });
      });
  };

  const onClickCancelAddJob = () => {
    setErrMessage("");
    setShowAddJobDept(false);
    setNewDept({});
    setNewJob("");
    setNewPositionTotal(undefined);
    unsavedChanges.value = false;
    setOrgToSave(false);
  };

  const renderAddJob = () => {
    return (
      <>
        <Row className="align-items-center my-3">
          <Col xs={4}>
            <SelectObjectTypeahead
              initialOption="Search or type to create"
              label="Department"
              value={newDept}
              options={departments}
              onUpdate={(e: any) => updateNewDept(e)}
              focused={true}
              required={true}
              allowCreate={true}
              onCreateOption={async (inputValue: string) => {
                const newDepartment = await onAddDepartment(inputValue);
                setNewDept(newDepartment);
                return newDepartment;
              }}
            />
          </Col>
          <Col xs={6}>
            <Input label="Job" type="text" value={newJob} onUpdate={(e: any) => updateNewJob(e)} required={true} />
          </Col>
          <Col xs={2}>
            <Input
              label="Positions #"
              type="number"
              value={newPositionTotal}
              onUpdate={(e: any) => updateNewPositionTotal(e)}
              required={true}
            />
          </Col>
        </Row>
        <Row className="mb-3">
          <Col xs={12} lg={8}>
            <Stack direction="horizontal" gap={3}>
              <Button
                className="app-secondary-color button"
                onClick={() => onClickSaveJob(false, newDept.id)}
                disabled={!newDept || !newJob || !newPositionTotal ? true : false}
              >
                Save and Add Another
              </Button>
              <div className="vr" />
              <Button
                className="app-secondary-color button"
                onClick={() => onClickSaveJob(true, newDept.id)}
                disabled={!newDept || !newJob || !newPositionTotal ? true : false}
              >
                Save and Close
              </Button>
              <div className="vr" />
              <Button className="app-primary-color button" onClick={() => onClickCancelAddJob()}>
                Cancel
              </Button>
            </Stack>
          </Col>
        </Row>
      </>
    );
  };

  return (
    <>
      {jobs.length === 0 ? (
        <>
          <p className="mt-2">No Job Records</p>
          {showAddJobDept && renderAddJob()}
        </>
      ) : (
        <>
          {showAddJobDept && renderAddJob()}
          <Row>
            <Col xs={12}>
              <Stack gap={3}>
                {jobs?.map((dept: any, index: number) => (
                  <DepartmentCard
                    key={dept[0]?.department_id || index}
                    department={dept}
                    getJobs={getJobs}
                    setOrgToSave={setOrgToSave}
                    setErrMessage={setErrMessage}
                    setShowToast={setShowToast}
                    setToastText={setToastText}
                    setToastBody={setToastBody}
                  />
                ))}
              </Stack>
            </Col>
          </Row>
        </>
      )}
      <Row className="mb-5"></Row>
    </>
  );
};

export default Jobs;
